// functions
function scrolledDown(){
  let scroll = window.scrollY || document.documentElement.scrollTop;
  if(scroll > 0){
    document.body.classList.add('custom--scrolled');
  } else {
    document.body.classList.remove('custom--scrolled');
  }
}

// events
document.addEventListener('scroll', scrolledDown, {
  passive: true
});
window.addEventListener('load', scrolledDown);